{
  "pageTitle": "Welcome",
  "morning": "Good morning",
  "afternoon": "Good afternoon",
  "evening": "Good evening",
  "up": "Up",
  "down": "Down",
  "totalInvoices": "Total Invoices",
  "totalPaid": "Total Paid",
  "pendingProcessing": "Pending Processing",
  "avgMonthly": "Avg. Monthly",
  "comboTitle": "Latest Invoice Summary",
  "noInvoice": "No invoice",
  "noData": "No invoice data yet",
  "comboEmptyHint": "Add an address and run scraping to see results here.",
  "viewActions": "Go to Actions"
}
